import { FC, useState, useCallback } from 'react';
import { Modal } from 'ui/Modal';
import { Button } from 'components/Button';
import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { Input } from 'components/Input';
import { DocumentIcon } from 'components/icons/DocumentIcon';
import { DeleteIcon } from 'components/icons/DeleteIcon';

export interface AddDocumentLinkModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  onAddDocument: (url: string) => void;
}

export const AddDocumentLinkModal: FC<AddDocumentLinkModalProps> = ({
  onClose,
  isModalOpen,
  onAddDocument,
}) => {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  const handleAddDocument = useCallback(() => {
    setError('');
    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
      setError('Link is required');
      return;
    }
    if (!trimmedUrl.startsWith('https://docs.google.com/spreadsheets')) {
      setError('Only Google Sheets links are supported');
      return;
    }

    onAddDocument(trimmedUrl);
    setUrl('');
    onClose();
  }, [url, onAddDocument, onClose]);

  return (
    <Modal onClose={onClose} open={isModalOpen}>
      <Box className="absolute left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-1/2 transform px-5 md:max-w-[600px]">
        <Box className="flex w-full flex-col gap-8 rounded-2xl bg-white px-6 py-8">
          <Typography
            variant="pSemiboldBlack"
            align="center"
            className="text-black"
          >
            Add link to document
          </Typography>
          <Input
            onChange={(event) => setUrl(event.target.value)}
            placeholder="Paste link here"
            startIcon={<DocumentIcon className="h-6 w-6" />}
            endIcon={
              <DeleteIcon
                className="h-6 w-6 cursor-pointer text-red"
                onClick={(event) => {
                  event.preventDefault();
                  setUrl('');
                }}
              />
            }
            value={url}
            error={!!error}
            helperText={error}
          />
          <Button
            className="mx-auto w-full max-w-[90px]"
            onClick={handleAddDocument}
            disabled={!url.trim()}
          >
            <Typography>Add</Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
